import React from "react";
import { Container } from "./Container";
import { Navbar } from "../Navbar/Navbar";
import { Footer } from "../Footer/Footer";
import { BottomNavbar } from "../BottomNavbar/BottomNavbar";

export const MainLayout = ({
  children,
  fluid,
  className,
  hideFooter = false,
  hideHeaderIcons = false,
  homeHref,
}) => (
  <>
    <Navbar hideIcons={hideHeaderIcons} homeHref={homeHref} />
    <Container fluid={fluid} className={className}>
      {children}
    </Container>
    {!hideFooter && (
      <div className="search-bar-mobile">
        <BottomNavbar />
      </div>
    )}
    {!hideFooter && (
      <div className="footer1">
        <Footer />
      </div>
    )}
  </>
);
